var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('div',{staticClass:"counter-text fz-72"},[_vm._v(_vm._s(_vm.timeText.join(':')))])])}
var staticRenderFns = []

export { render, staticRenderFns }